import React from 'react';
import PropTypes from 'prop-types';

import PrimaryAction from '../PrimaryAction';
import SecondaryAction from '../SecondaryAction';
import Spacing from '../Spacing';

export const ModalActionTypes = ['', 'primary', 'secondary'];
export const ModalActionDefaultType = 'secondary';

const defaultProps = {
  type: ModalActionDefaultType,
  onClick: () => {},
};

const propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.oneOf(ModalActionTypes),
  onClick: PropTypes.func,
};

const ModalAction = ({
  name,
  type,
  onClick,
  ...rest
}) => {
  let ActionTypeComponent;
  if (type === 'primary') {
    ActionTypeComponent = PrimaryAction;
  } else {
    ActionTypeComponent = SecondaryAction;
  }

  return (
    <Spacing h={2}>
      <ActionTypeComponent
        onClick={onClick}
        {...rest}
      >
        {name}
      </ActionTypeComponent>
    </Spacing>
  );
};

ModalAction.defaultProps = defaultProps;
ModalAction.propTypes = propTypes;

export default ModalAction;
